import { x } from '@xstyled/styled-components';
import React from 'react';

interface Props {
  current: number;
  total: number;
}

export const ProgressBar = ({ current, total }: Props) => {
  const items: number[] = [];
  for (let i = 0; i < total; i++) items.push(i);
  return (
    <x.div
      display="flex"
      h="6px"
      gap="sm"
      gridArea="progress"
      alignSelf="center"
      justifySelf="stretch"
    >
      {items.map(i => (
        <x.div
          key={i}
          borderRadius="3px"
          backgroundColor={i <= current ? '#FFF' : 'greyMed'}
          border={'1px solid #a8a8a8'}
          transition="all 0.4s ease-in-out"
          flex="1"
        />
      ))}
    </x.div>
  );
};
